import { render, staticRenderFns } from "./duogetwo.vue?vue&type=template&id=4da1ae98&scoped=true"
import script from "./duogetwo.vue?vue&type=script&lang=js"
export * from "./duogetwo.vue?vue&type=script&lang=js"
import style0 from "./duogetwo.vue?vue&type=style&index=0&id=4da1ae98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da1ae98",
  null
  
)

export default component.exports